import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "react-bootstrap";
import "../../assets/styles/scheduledChanges.scss";

const ScheduledChangesButtons = ({
  onSearch,
  onApprove,
  onReject,
  isApproving = false,
  isRejecting = false,
}) => {
  const { instance, accounts } = useMsal();
  const activeAccount = instance.getActiveAccount() || accounts?.[0];
  const claims = activeAccount?.idTokenClaims || {};
  const rolesRaw = claims.roles || claims.role || claims.groups;
  const roles = Array.isArray(rolesRaw)
    ? rolesRaw
    : rolesRaw
      ? [rolesRaw]
      : [];
  const isSuperUser = roles.includes("ROLE_SUPERUSER");

  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        onSearch?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onSearch]);

  return (
    <div className="sc-buttons">
      {isSuperUser && (
        <Button
          className="sc-btn sc-btn-accept sc-btn-iconOnly"
          variant="outline-success"
          aria-label="Akceptuj"
          title="Akceptuj"
          disabled={isApproving}
          onClick={() => {
            if (typeof onApprove === "function") onApprove();
          }}
        >
          <span className="sc-btn-icon" aria-hidden="true">
            <i className="bi bi-check-lg" />
          </span>
          <span className="sc-btn-label">Akceptuj</span>
        </Button>
      )}

      <Button
        className="sc-btn sc-btn-reject sc-btn-iconOnly"
        variant="outline-danger"
        aria-label="Odrzuć"
        title="Odrzuć"
        disabled={isRejecting}
        onClick={() => {
          if (typeof onReject === "function") onReject();
        }}
      >
        <span className="sc-btn-icon" aria-hidden="true">
          <i className="bi bi-x-lg" />
        </span>
        <span className="sc-btn-label">Odrzuć</span>
      </Button>

      <Button
        className="sc-btn sc-btn-search sc-btn-iconOnly"
        variant="outline-secondary"
        aria-label="Szukaj"
        title="Szukaj"
        onClick={() => {
          if (typeof onSearch === "function") onSearch();
        }}
      >
        <span className="sc-btn-icon" aria-hidden="true">
          <i className="bi bi-search" />
        </span>
        <span className="sc-btn-label">Szukaj</span>
      </Button>
    </div>
  );
};

export default ScheduledChangesButtons;
